export default __webpack_public_path__ + "static/media/Penny.3e0d0c6c.png";